import * as React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import axios from "axios";
import AxiosConfig from "../../../utilities/AxiosConfig";
import { connect } from "react-redux";
// Bootstrap Imports
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
// React Table Imports
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
// Component Imports
import Loader from "../../../components/common/Loader";
// Function Imports
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import logger from "../../../utilities/logging";
import CustomSearch from "../../../components/table/CustomSearch";
import SearchDropdown from "../../../components/admin/SearchDropdown";
import { ModalFooter } from "react-bootstrap";
import { qsStringify } from "src/utilities/helper";
import "./EndpointSecurity.css";

//urls accessed by the Endpoint Security page
const urls = [
  "/api/Portal/GetEndPointSecurityData",
  "/api/Portal/AddEndPointSecurity",
  "/api/Portal/DeleteEndPointSecurity",
  "/api/Portal/TestEndPointSecurity/",
  "/api/Portal/UpdateEndPointSecurity/",
];

//page used to view, edit, and add endpoint secutity roles
class EndpointSecurity extends React.Component {
  //Constructor for setting up all variables in page
  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      errorMessage: null,
      allUsers: [],
      data: [],
      loading: true,
      loadingUsers: false,
      isModalOpen: false,
      newClient: {
        Route: "",
        Controller: "",
        Action: "",
        Verb: "",
        Role: "",
        Required: false,
      },
      numRows: 0,
      show: false,
      controllerSearch: "",
      isControllerDropdownOpen: false,
      roleSearch: "",
      isRoleDropdownOpen: false,
      actionSearch: "",
      selectedActionRef: React.createRef(),
      selectedController: "",
      selectedRow: "",
      newEndpoint: [],
      isActive: false,
      AddRoleModal: false,
      selectRoles: [],
      Roles: [],
      numRoles: "",
      hasChanged: false,
      stageDelete: "",
      setDelete: false,
      cancelConfirmation: false,
      edit: false,
      saveChange: false,
      tempRow: "",
      rowDelete: false,
      testRoute: false,
      users: "",
      stageTest: [],
      selectedUser: "",
      testResult: "",
      newRoles: [],
      tempController: "",
      count: 100,
      newRole: false,
      allRoles: "",
      rows: [],
      disable: false,
      controllers: [],
      roles: [],
      timerId: 0,
    };
  }

  //<--Start Modal Functions-->

  //function to open add/edit role modal
  handleShow = (row = null) => {
    this.setState({
      show: true,
      selectedRow: row,
      selectedController: row?.ControllerName || "",   // Set selected controller for auto-population
      selectedAction: row?.ActionName || "",           // Set selected action for auto-population
      controllerSearch: row?.ControllerName || "",    // Set controller search field value
      actionSearch: row?.ActionName || "",             // Set action search field value
      isControllerDropdownOpen: false,
      isActionDropdownOpen: false,
    });
  };

  getRows = (controller) => {
    let copyRow = [];
    this.state.data.forEach((i) =>
      i.Controller === controller ? copyRow.push(i) : null
    );
    return copyRow;
  };
  //functopn to select controller in add/edit modal
  onControllerSelect = (e) => {
    let controller = this.state.controllers.find((obj) => {
      return obj.ControllerName === e;
    });
    //console.log(controller)
    //let copyRow = this.getRows(e)
    this.setState({
      selectedController: controller,
      selectedRow: "",
      newEndpoint: [],
      isActive: "",
      selectRoles: "",
      hasChanged: false,
      newRoles: [],
    });
  };

  //function to select Action row in add/edit modal
  onRowClick = (row, role, data, controller) => {
    if (!row || typeof row !== "object") {
      console.warn("Invalid row data in onRowClick:", row);
      return;
    }
  
    // Ensure actionName is defined and not "Unknown"
    const actionName = row.ActionName && row.ActionName !== "Unknown" ? row.ActionName : "Unknown";
  
    // Find action in controller
    let action = this.state.controllers
      .find((obj) => obj.ControllerName === controller)?.Actions
      .filter((obj) => obj.ActionName === actionName) || [];
  
    // Filter in-use roles from data
    let inUseRoles = (Array.isArray(data) ? data : [])
      .filter((i) => i.Controller === controller && i.Action === actionName)
      .map((i) => ({
        PortalRoleName: i.PortalRoleName,
        IsRequired: i.IsRequired,
        PortalRoleId: i.PortalRoleId,
        delete: true,
        PortalEndPointSecurityId: i.PortalEndPointSecurityId,
      }));
  
    // Ensure allRoles is not empty
    let copyRole = [...this.state.allRoles];
    console.log("All Roles Before Filtering:", copyRole);
  
    // Remove already used roles
    inUseRoles.forEach((i) => {
      copyRole = copyRole.filter((el) => el.PortalRoleId !== i.PortalRoleId);
    });
  
    console.log("Remaining Roles After Filtering:", copyRole);
  
    // Update state
    this.setState({
      selectedRow: {
        ActionName: actionName,
        Route: row.Route || "",
        HttpMethods: row.HttpMethods || [],
      },
      isActive: row.PortalEndPointSecurityId,
      selectRoles: inUseRoles,
      Roles: copyRole, // Updated roles
      numRoles: inUseRoles.length,
      newRoles: [...new Set(copyRole.map((role) => role.RoleName))],
      newEndpoint: [],
      hasChanged: false,
      newRole: false,
    });
  
    // Alert if multiple endpoints are affected
    if (action.length > 1) {
      alert("You are working with two or more Endpoints, any changes made will affect both Endpoints.");
    }
  };
  
  
  
  //function to handle changes to the is required column of the role table in the add/edit modal
  handleChecks = (r, e) => {
    const copyEndpoint = Array.from(this.state.selectRoles);
    if (copyEndpoint[copyEndpoint.indexOf(r)].IsRequired === true)
      copyEndpoint[copyEndpoint.indexOf(r)].IsRequired = false;
    else copyEndpoint[copyEndpoint.indexOf(r)].IsRequired = true;
    this.setState({ selectRoles: copyEndpoint });
    this.setState({ hasChanged: true });
  };

  //functions to open/close addRole modal in the add/edit modal
  showAddRole = () => this.setState({ AddRoleModal: true });
  closeAddRole = () => this.setState({ AddRoleModal: false });

  //function to add a role to the roles table in the add/edit modal
  addRole = (r) => {
    const copyEndpoint = Array.from(this.state.selectRoles);
    let copyRoles = Array.from(this.state.Roles);
    let del;
    let key;
    copyRoles.forEach((i) =>
      i.RoleName === r.target.value
        ? ([key, del] = [i.PortalRoleId, i.delete])
        : null
    );
    copyEndpoint.push({
      PortalRoleName: r.target.value,
      IsRequired: false,
      PortalRoleId: key,
      delete: del,
    });
    copyRoles = copyRoles.filter((el) => el.RoleName !== r.target.value);
    this.setState({ selectRoles: copyEndpoint });
    this.setState({ Roles: copyRoles, hasChanged: true, newRole: true });
    this.closeAddRole();
  };

  //function to delete roles from the roles table in the add/edit modal
  deleteRole = () => {
    //console.log(this.state.selectedRow, this.state.selectedController.ControllerName, this.state.stageDelete)
    const copyEndpoint = Array.from(this.state.selectRoles);
    const copyRoles = Array.from(this.state.Roles);
    copyRoles.push({
      PortalRoleId: this.state.stageDelete.PortalRoleId,
      RoleName: this.state.stageDelete.PortalRoleName,
      delete: this.state.stageDelete.delete,
    });
    copyEndpoint.splice(copyEndpoint.indexOf(this.state.stageDelete), 1);
    this.setState({ selectRoles: copyEndpoint });
    this.setState({
      Roles: copyRoles,
      hasChanged: true,
      stageDelete: "",
      setDelete: false,
    });
  };

  //function to close the delete role modal without deleting a role
  safeCloseDelete = (r) => {
    this.setState({ stageDelete: "", setDelete: false, rowDelete: false });
  };

  //functions to open the save changes modal
  saveChanges = (i) => {
    this.setState({ saveChange: true, tempRow: i });
  };
  controllerSaveChanges = (e) => {
    this.setState({ saveChange: true, tempController: e.target.value });
  };

  //function to close save changes modal
  closeChange = () => {
    this.setState({ saveChange: false, tempRow: "", tempController: "" });
  };

  //function to save changes made to role table in add/edit modal and then switch to new action or controller
  yesSave = async (row, role, data, controller) => {
    //console.log( this.state.selectedRow, this.state.selectedController.ControllerName, this.state.selectRoles, this.state.rows, this.state.newRoles)
    await this.handleSave(
      this.state.selectRoles,
      this.state.selectedController.ControllerName,
      this.state.selectedRow,
      this.state.rows,
      this.state.newRoles,
      false
    ).then(
      controller
        ? this.setState({
          selectedRow: "",
          newEndpoint: [],
          isActive: "",
          selectRoles: "",
          hasChanged: false,
          newRoles: [],
          newRole: false,
          selectedController: this.state.controllers.find((obj) => {
            return obj.ControllerName === controller;
          }),
        })
        : null,
      row
        ? this.onRowClick(
          row,
          role,
          data,
          this.state.selectedController.ControllerName
        )
        : null,
      this.setState({ tempRow: "", saveChange: false, tempController: "" })
    );
    //let copyRow = this.getRows(controller)
  };

  //function to exit save changes modal, and switch to new action or controller
  noSave = (row, role, data, controller) => {
    // let copyRow = this.getRows(controller)
    if (controller) {
      this.setState({
        selectedController: this.state.controllers.find((obj) => {
          return obj.ControllerName === controller;
        }),
        selectedRow: "",
        newEndpoint: [],
        isActive: "",
        selectRoles: "",
        hasChanged: false,
        newRoles: [],
        newRole: false,
      });
    }
    if (row) {
      this.onRowClick(
        row,
        role,
        data,
        this.state.selectedController.ControllerName
      );
    }
    this.setState({ tempRow: "", saveChange: false, tempController: "" });
  };

  //function to open cancel modal
  openCancel = () => {
    this.setState({ cancelConfirmation: true });
  };

  //function to close cancel modal without closing any other modal
  safeCloseCancel = () => {
    this.setState({ cancelConfirmation: false });
  };

  //function to save changes made to role table in add/edit modal
  async handleSave(roles, controller, row, rows, newRoles, close = true) {
    //console.log(controller)
    this.setState({ hasChanged: false, disable: true });
    let c = 0;
    for (var i = 0; i < roles.length; i++) {
      c = c + 1;
      if (newRoles.indexOf(roles[i].PortalRoleName) > -1) {
        await this.addEndpoints(roles[i], row, controller, c);
      }
      //r-18-lint-cn
      //eslint-disable-next-line
      let temp = rows.find(
        (el) => el.PortalRoleName === roles[i].PortalRoleName
      );
      if (temp !== undefined) {
        await this.editEndpoints(roles[i], row, controller, temp);
      }
    }
    //console.log(rows)
    rows.forEach((i) =>
      roles.find((o) => o.PortalRoleName === i.PortalRoleName)
        ? null
        : (this.deleteEndpoints(
          {
            ActionName: i.Action,
            Route: i.Route,
            HttpMethods: i.HttpMethods,
          },
          i.Controller,
          {
            PortalRoleName: i.PortalRoleName,
            IsRequired: i.IsRequired,
            PortalRoleId: i.PortalRoleId,
            PortalEndPointSecurityId: i.PortalEndPointSecurityId,
          }
        ),
          //console.log("delete", i),
          this.getEndpoints())
    );
    c = c + this.state.count + 1;
    this.setState({ count: c });
    this.getEndpoints();

    if (close) {
      this.handleClose();
    }
  }

  //function to close the add/edit
  handleClose = () => {
    this.setState({
      show: false,
      edit: false,
      testRoute: false,
      rowDelete: false,
      newRole: false,
      hasChanged: false,
      cancelConfirmation: false,
    });
    this.setState({
      selectedController: "",
      selectedRow: "",
      selectRoles: "",
      controllerSearch: "",
      actionSearch: "",
      isControllerDropdownOpen: false,
      isActionDropdownOpen: false,
      stageTest: [],
      testResult: "",
      newRoles: [],
    });
  };

  //<--End of Modal Functions-->

  //<--Start Main Table Functions-->

  //constant to format main Endpoint Security table
  columns = [
    {
      dataField: "Route",
      text: "Route",
      editable: false,
      headerFormatter: (column) => (
        <>
          <div className="justify-content-start table-heads">
            <span>Route</span>
          </div>
          <div className=" d-flex justify-content-end">
            <i className="material-icons cursor-on-hover text-right">
              arrow_drop_up
            </i>
          </div>
        </>
      ),
      sort: true,
    },
    {
      dataField: "Controller",
      text: "Controller",
      editable: false,
      headerFormatter: (column) => (
        <>
          <div className="justify-content-start table-heads">
            <span>Controller</span>
          </div>
          <div className=" d-flex justify-content-end">
            <i className="material-icons cursor-on-hover text-right">
              arrow_drop_up
            </i>
          </div>
        </>
      ),
      sort: true,
    },
    {
      dataField: "Action",
      text: "Action",
      editable: false,
      headerFormatter: (column) => (
        <>
          <div className="justify-content-start table-heads">
            <span>Action</span>
          </div>
          <div className=" d-flex justify-content-end">
            <i className="material-icons cursor-on-hover text-right">
              arrow_drop_up
            </i>
          </div>
        </>
      ),
      sort: true,
    },
    {
      dataField: "HttpMethods",
      text: "Verb",
      editable: true,
      headerFormatter: (column) => (
        <>
          <div className="justify-content-start table-heads">
            <span>Verb</span>
          </div>
          <div className=" d-flex justify-content-end">
            <i className="material-icons cursor-on-hover text-right">
              arrow_drop_up
            </i>
          </div>
        </>
      ),
      headerStyle: (column, colIndex) => {
        return {
          width: "65px",
        };
      },
      sort: true,
    },
    {
      dataField: "PortalRoleName",
      text: "Role",
      editable: false,
      headerFormatter: (column) => (
        <>
          <div className="justify-content-start table-heads">
            <span>Role</span>
          </div>
          <div className=" d-flex justify-content-end">
            <i className="material-icons cursor-on-hover text-right">
              arrow_drop_up
            </i>
          </div>
        </>
      ),
      sort: true,
    },
    {
      dataField: "IsRequired",
      text: "Required",
      editable: false,

      headerFormatter: (column) => (
        <>
          <div className="justify-content-start table-heads">
            <span>Required</span>
          </div>
          <div className=" d-flex justify-content-end">
            <i className="material-icons cursor-on-hover text-right">
              arrow_drop_up
            </i>
          </div>
        </>
      ),
      headerStyle: (column, colIndex) => {
        return {
          width: "100px",
        };
      },
      sort: true,
    },
    {
      isDummyField: true,
      dataField: "df-1",
      text: "Actions",
      formatter: (cell, row, rowIndex) => (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <i
            className="material-icons cursor-on-hover"
            onClick={() => this.openDelete(row)}
          >
            delete
          </i>
          <i
            className="material-icons cursor-on-hover"
            onClick={() => this.openEdit(row, this.state.data)}
          >
            edit
          </i>
          <i
            className="material-icons cursor-on-hover"
            onClick={() => this.filterUsers(row)}
          >
            bolt
          </i>
        </div>
      ),
      headerFormatter: (column) => (
        <div className="w-100 d-flex justify-content-end"></div>
      ),
      headerStyle: (column, colIndex) => {
        return {
          width: "65px",
        };
      },
      editable: false,
    },
  ];

  //Function to open Endpoint Delete modal
  openDelete = (row) => {
    this.setState({ rowDelete: true, stageDelete: row });
  };

  //Function to open add/edit modal in edit mode
  openEdit = (row, data) => {
    let role = [
      ...new Map(data.map((item) => [item["PortalRoleName"], item])).values(),
    ];
    role = role.map((i) => ({
      PortalRoleId: i.PortalRoleId,
      PortalRoleName: i.PortalRoleName,
    }));
    this.setState({ show: true, edit: true });
    // let copyRow = this.getRows(row.controller)
    this.setState({
      selectedController: this.state.controllers.find((obj) => {
        return obj.ControllerName === row.Controller;
      }),
      selectedRow: "",
      newEndpoint: [],
      isActive: "",
      selectRoles: "",
      hasChanged: false,
      newRoles: [],
    });
    let Actions = this.state.controllers.find((obj) => {
      return obj.ControllerName === row.Controller;
    }).Actions;
    let actionRow = Actions.find((obj) => {
      return obj.ActionName === row.Action;
    });
    //console.log(row.Action, actionRow)
    this.onRowClick(
      actionRow,
      role,
      data,
      this.state.controllers.find((obj) => {
        return obj.ControllerName === row.Controller;
      }).ControllerName
    );
  };

  //function to delete endpoint from Endpoint Security table
  async deleteRow(row, controller, roles) {
    await this.deleteEndpoints(row, controller, roles);
    this.getEndpoints();
    this.setState({ stageDelete: "", rowDelete: false });
  }

  //function to open Endpoint test modal, and to filter out users without proper roles to access endpoint
  filterUsers = (row) => {
    this.setState({
      selectedRole: row.PortalRoleName,
      testRoute: true,
      stageTest: row,
    });
    // Fetch users lazily — skip if already loaded from a previous modal open
    if (!this.state.allUsers.length) {
      this.getUsers();
    }
  };


    //<--End Main Table Functions-->

  //<--Start API Functions-->

  //function to load endpoint and user data
  componentDidMount() {
    this._isMounted = true;
    this.getEndpoints();
    // getUsers is deferred — only fetched when the Test User modal is opened
  }
  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.timerID);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.selectedRow !== prevState.selectedRow && this.selectedActionRef) {
      this.selectedActionRef.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  //function to get all users from API
  getUsers = () => {
    // Clear any previous error so the modal shows a fresh loading state on retry
    this.setState({ loadingUsers: true, errorMessage: null });
    const configValue = AxiosConfig.configValue();
    //console.log(process.env.REACT_APP_API_URL + "/api/user/*"+"/")
    axios
      .get(process.env.REACT_APP_API_URL + "/api/user/*", configValue)
      .then((response) => {
        let temp = response.data.users;
        temp.sort((a, b) => {
          let fa = a.UserName.toLowerCase(),
            fb = b.UserName.toLowerCase();

          if (fa < fb) {
            return -1;
          }
          if (fa > fb) {
            return 1;
          }
          return 0;
        });
        //console.log("response.data", response.data.users);
        this.setState({
          allUsers: temp,
          loadingUsers: false,
        });
      })
      .catch((error) => {
        //console.log(error);
        // loadingUsers must be cleared on failure so the modal doesn't stay in a loading state
        this.setState({
          loadingUsers: false,
          errorOpen: true,
          errorMessage: "Error Receiving Users from API.",
        });
        AxiosConfig.handleError(error);
      });
  };

  //function to get all enpoints from API
  getEndpoints = async () => {
    this.setState({ loading: true });
    //console.log(process.env.REACT_APP_API_URL + urls[0] + "/");
    let roles = [];
    roles.push({ PortalRoleId: -1, RoleName: "*" });
    axios
      .get(
        process.env.REACT_APP_API_URL + urls[0] + "/",
        AxiosConfig.configValue()
      )
      .then((response) => {
        const res = response.data;
        if (!res.HasError) {
          this.setState({
            data: res.Data,
            loading: false,
            numRows: res.Data.length,
            disable: false,
          });
        } else {
          this.setState({ errorMsg: res.ErrorMessage });
        }
      })
      .catch((error) => {
        this.setState({ data: [], errorMsg: "Unknown Error" });
        //console.log(error);
        logger.Error({
          EventMessage: `EndpointSecurity -> getEndpoints -> Error : ${JSON.stringify(
            error
          )}`,
          EventCategory: "httprequest",
        });
        AxiosConfig.handleError(error);
      });
    //r-18-lint-cn
    //eslint-disable-next-line
    axios
      .get(
        process.env.REACT_APP_API_URL +
        "/api/Portal/GetEndPointSecurityReference" +
        "/",
        AxiosConfig.configValue()
      )
      .then(
        (response) => (
          response.data.Controllers.forEach((i) =>
            i.Actions.push({
              ActionName: "*",
              Route: `/${i.ControllerName}/*`,
              HttpMethods: ["--"],
            })
          ),
          //console.log(response.data),
          this.setState({
            controllers: response.data.Controllers,
            allRoles: [...roles, ...response.data.Roles],
          })
        )
      );
  };

  //function to run test by having user access selected endpoint
  performTest = () => {
    //console.log(this.state.stageTest, this.state.selectedUser)
    axios
      .post(
        process.env.REACT_APP_API_URL + urls[3],
        qsStringify({
          EmployeeId: this.state.selectedUser,
          Controller: this.state.stageTest.Controller,
          Action: this.state.stageTest.Action,
        }),
        AxiosConfig.configValue()
      )
      .then((response) => {
        //console.log(response)
        if (response.data.Authorized) {
          alert(`${this.state.selectedUser} is authorized`);
        } else {
          alert(`${this.state.selectedUser} is not authorized`);
        }
      });
  };

  //function to add endpoint to API
  async addEndpoints(r, row, controller) {
    //console.log(process.env.REACT_APP_API_URL + urls[1]+"/")
    await axios
      .post(
        process.env.REACT_APP_API_URL + urls[1] + "/",
        qsStringify({
          Action: row.ActionName,
          Controller: controller,
          CreatedBy: this.props.username,
          CreatedDate: Date.now.toString(),
          HttpMethods: row.HttpMethods,
          IsRequired: r.IsRequired,
          PortalRoleId: r.PortalRoleId,
          PortalRoleName: r.PortalRoleName,
          Route: row.Route,
          UserId: this.props.userid,
        }),
        AxiosConfig.configValue()
      )
      .then((response) => {
        //console.log("add", response.data)
      })
      .catch((error) => {
        alert("There was an error Adding Endpoints");
        //console.log(error);
        logger.Error({
          EventMessage: `EndpointSecurity -> addEndpoints -> Error : ${JSON.stringify(
            error
          )}`,
          EventCategory: "httprequest",
        });
        AxiosConfig.handleError(error);
      });
  }
  async editEndpoints(r, row, controller, origin) {
    //console.log(process.env.REACT_APP_API_URL + urls[4])
    await axios
      .post(
        process.env.REACT_APP_API_URL + urls[4],
        qsStringify({
          Action: row.ActionName,
          Controller: controller,
          CreatedBy: origin.CreatedBy,
          CreatedDate: origin.CreatedDate,
          HttpMethods: row.HttpMethods,
          IsRequired: r.IsRequired,
          PortalRoleId: r.PortalRoleId,
          PortalRoleName: r.PortalRoleName,
          Route: row.Route,
          UserId: origin.UserId,
          PortalEndPointSecurityId: origin.PortalEndPointSecurityId,
          ModifiedBy: this.props.userName,
          ModifiedDate: Date.now.toString(),
        }),
        AxiosConfig.configValue()
      )
      .then((response) => {
        //console.log("edit", response.data)
      })
      .catch((error) => {
        alert("There was an error Editing Endpoints");
        //console.log(error);
        logger.Error({
          EventMessage: `EndpointSecurity -> editEndpoints -> Error : ${JSON.stringify(
            error
          )}`,
          EventCategory: "httprequest",
        });
        AxiosConfig.handleError(error);
      });
  }
  //function to delete endpoint from API
  async deleteEndpoints(row, controller, r) {
    //console.log(process.env.REACT_APP_API_URL + urls[2] + "/")
    await axios
      .post(
        process.env.REACT_APP_API_URL + urls[2] + "/",
        qsStringify({
          Action: row.ActionName,
          Controller: controller,
          DeletedBy: this.props.username,
          DeletedDate: Date.now.toString(),
          HttpMethods: row.HttpMethods,
          IsRequired: r.IsRequired,
          PortalRoleId: r.PortalRoleId,
          PortalRoleName: r.PortalRoleName,
          Route: row.Route,
          PortalEndPointSecurityId: r.PortalEndPointSecurityId,
        }),
        AxiosConfig.configValue()
      )
      .then((response) => {
        //console.log("delete",response.data)
      })
      .catch((error) => {
        alert("There was an error Deleting Endpoints");
        //console.log(error);
        logger.Error({
          EventMessage: `EndpointSecurity -> deleteEndpoints -> Error : ${JSON.stringify(
            error
          )}`,
          EventCategory: "httprequest",
        });
        AxiosConfig.handleError(error);
      });
  }
  //<--End API functions-->

  render() {
    //r-18-lint-cn
    //eslint-disable-next-line
    const {
      allRoles,
      controllers,
      testResult,
      selectedUser,
      isActive,
      users,
      testRoute,
      rowDelete,
      selectedRow,
      selectedController,
      show,
      data,
      loading,
      loadingUsers,
      numRows,
      setDelete,
      AddRoleModal,
      selectRoles,
      Roles,
      cancelConfirmation,
      edit,
      hasChanged,
      saveChange,
    } = this.state;
    let role = [
      ...new Map(data.map((item) => [item["PortalRoleName"], item])).values(),
    ];
    role = role.map((i) => ({
      PortalRoleId: i.PortalRoleId,
      PortalRoleName: i.PortalRoleName,
      delete: false,
    }));
    return (
      <>
        {!this.state.errorMsg && (
          <>
            {/*Container for the Main table of the page*/}
            <Container fluid>
              <ToolkitProvider
                className="endpointTable"
                keyField="PortalEndPointSecurityId"
                bootstrap4
                data={data}
                columns={this.columns}
                search
              >
                {(props) => (
                  <div>
                    {/* controls go here */}
                    {loading ? (
                      <Loader title="Loading Endpoints..." />
                    ) : (
                      <div className="w-100">
                        <h2 className="doc-title">Endpoint Security</h2>
                        <div className="custom-search-bar">
                          <CustomSearch
                            placeholder="Filter"
                            {...props.searchProps}
                          ></CustomSearch>
                        </div>
                        <i
                          className="add-end material-icons md-36 cursor-on-hover"
                          onClick={this.handleShow}
                        >
                          add
                        </i>
                        <p
                          data-tip
                          data-for="unique-users-tt"
                          className="text-left num-rows"
                        >
                          Showing: {numRows} of
                          <span> {data?.length}</span>
                        </p>
                        <div className="table-scroll">
                          <BootstrapTable
                            {...props.baseProps}
                            hover={true}
                            condensed={true}
                            noDataIndication={() => (
                              <h5 className="p-2">No Enpoints Found...</h5>
                            )}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </ToolkitProvider>
            </Container>
            {/*Add/edit modal*/}
            {
              <Modal
                show={show}
                onHide={hasChanged ? this.openCancel : this.handleClose}
                size="xl"
              >

                <Modal.Header closeButton>
                  {edit ? (
                    <Modal.Title>Edit Route</Modal.Title>
                  ) : (
                    <Modal.Title>Add Route</Modal.Title>
                  )}
                </Modal.Header>
                <Modal.Body>

                  {/* Controller Search & Dropdown */}
                  <div ref={this.controllerDropdownRef} style={{ position: "relative", width: "100%", marginBottom: "10px" }}>
                    Search Controllers:
                    <br></br>
                    <SearchDropdown
                      placeholder="Search Controllers..."
                      options={this.state.controllers.map((c) => c.ControllerName)}
                      selectedValue={this.state.selectedController?.ControllerName}
                      onSelect={(controller) => this.onControllerSelect(controller)}
                      />

                    {this.state.isControllerDropdownOpen && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          right: 0,
                          maxHeight: 200,
                          overflowY: "auto",
                          backgroundColor: "white",
                          border: "1px solid #ddd",
                          zIndex: 1000,
                          boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                        }}
                      >
                        {controllers
                          .filter((c) =>
                            c.ControllerName.toLowerCase().includes((this.state.controllerSearch || "").toLowerCase())
                          )
                          .map((c) => (
                            <div
                              key={c.ControllerName}
                              onClick={() => {
                                this.onControllerSelect(c.ControllerName);
                                this.setState({ controllerSearch: c.ControllerName, isControllerDropdownOpen: false });
                              }}
                              style={{
                                padding: 8,
                                cursor: "pointer",
                                backgroundColor: this.state.selectedController?.ControllerName === c.ControllerName ? "#00BFFF" : "white",
                                color: this.state.selectedController?.ControllerName === c.ControllerName ? "white" : "black",
                              }}
                            >
                              {c.ControllerName}
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                  {/* Action Search & Table */}
                  {selectedController ? (
                    <>

                      Search Actions:
                      <br></br>
                      <CustomSearch
                        className = "w-50"
                        placeholder="Search Actions..."
                        onSearch={(value) => this.setState({ actionSearch: value })}
                      />

                      <div className="scrollable">
                        <table className="fixed_header">
                          <tbody>
                            <tr>
                              <th>Action</th>
                              <th>Route</th>
                              <th>Verb</th>
                            </tr>
                            {selectedController.Actions
                              .filter((i) =>
                                i.ActionName.toLowerCase().includes((this.state.actionSearch || "").toLowerCase())
                              )
                              .map((i, index) => (
                                <tr
                                  key={index}
                                  ref={(el) => {
                                    if (selectedRow?.ActionName === i.ActionName) {
                                      this.selectedActionRef = el;
                                    }
                                  }}
                                  style={{
                                    backgroundColor: selectedRow?.ActionName === i.ActionName ? "#00BFFF" : "",
                                    color: selectedRow?.ActionName === i.ActionName ? "white" : "",
                                  }}
                                  onClick={() => {
                                    if (selectedRow?.ActionName !== i.ActionName) {
                                      this.onRowClick(i, role, data, selectedController.ControllerName);
                                    }
                                  }}
                                >
                                  <td>{i.ActionName}</td>
                                  <td>{i.Route}</td>
                                  <td>{i.HttpMethods}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  ) : null}
                  {selectedRow ? (
                    <div style={{ width: "30%" }}>
                      <i
                        className="add-end material-icons cursor-on-hover"
                        style={{ float: "right" }}
                        onClick={this.state.disable ? null : this.showAddRole}
                      >
                        add
                      </i>
                      <p>Assigned Roles </p>
                      <table className="roleGrid">
                        <tbody>
                          <tr>
                            <th>Roles</th>
                            <th>Required</th>
                            <th></th>
                          </tr>
                          {(Array.isArray(selectRoles) ? selectRoles : []).map((r) => (
                            <tr key={r.PortalRoleId}>
                              <td>{r.PortalRoleName}</td>
                              <td>
                                <input
                                  type="checkbox"
                                  onChange={(e) => this.handleChecks(r, e)}
                                  checked={r.IsRequired}
                                  disabled={this.state.disable}
                                />
                              </td>
                              <td>
                                <i
                                  className="material-icons cursor-on-hover"
                                  onClick={
                                    this.state.disable
                                      ? null
                                      : () => this.setState({ stageDelete: r, setDelete: true })
                                  }
                                >
                                  delete
                                </i>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : null}
                </Modal.Body>
                <Modal.Footer>
                  {this.state.hasChanged ? (
                    <>
                      <Button variant="secondary" onClick={this.openCancel}>
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() =>
                          this.handleSave(
                            this.state.selectRoles,
                            this.state.selectedController.ControllerName,
                            this.state.selectedRow,
                            this.state.rows,
                            this.state.newRoles
                          )
                        }
                        disabled={
                          edit ? false : this.state.newRole ? false : true
                        }
                      >
                        Save
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button variant="secondary" onClick={this.handleClose}>
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        onClick={this.handleClose}
                        disabled
                      >
                        Save
                      </Button>
                    </>
                  )}
                </Modal.Footer>
              </Modal>
            }
            {/* Add Role Modal */}
            {
              <Modal show={AddRoleModal} onHide={this.closeAddRole} size="sm">
                <Modal.Header closeButton>
                  <Modal.Title>Available Roles</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                  <div style={{ position: "relative", width: "100%" }}>
                    {/* Search Input inside Dropdown */}
                    <SearchDropdown
                      label="Search Roles"
                      options={this.state.Roles.map((role) => role.RoleName)}
                      selectedValue={""}
                      onSelect={(roleName) => this.addRole({ target: { value: roleName } })}
                    />
                    {/* Role Dropdown - Shows only when typing/searching */}
                    {this.state.isRoleDropdownOpen && (
                      <select
                        onChange={this.addRole}
                        onBlur={() => setTimeout(() => this.setState({ isRoleDropdownOpen: false }), 200)}
                        defaultValue=""
                        size={Math.min(Roles.filter((role) =>
                          role.RoleName.toLowerCase().includes(this.state.roleSearch.toLowerCase())
                        ).length, 5)} // Limit visible options
                        style={{
                          width: "100%",
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          zIndex: 10,
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                        }}
                      >
                        {Roles.filter((role) =>
                          role.RoleName.toLowerCase().includes(this.state.roleSearch.toLowerCase())
                        ).map((e) => (
                          <option key={e.PortalRoleId}>{e.RoleName}</option>
                        ))}
                      </select>
                    )}
                  </div>
                </Modal.Body>
              </Modal>
            }
            {/*Delete Role Modal*/}
            {
              <Modal show={setDelete} size="sm">
                <Modal.Header>
                  <Modal.Title>
                    Delete {this.state.stageDelete.PortalRoleName}?
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>
                    Are you sure you want to delete{" "}
                    {this.state.stageDelete.PortalRoleName}?
                  </p>
                </Modal.Body>
                <ModalFooter>
                  <Button variant="secondary" onClick={this.safeCloseDelete}>
                    No
                  </Button>
                  <Button variant="primary" onClick={this.deleteRole}>
                    Yes
                  </Button>
                </ModalFooter>
              </Modal>
            }
            {/*Cancel Modal*/}
            {
              <Modal show={cancelConfirmation} size="sm">
                <Modal.Header>
                  <Modal.Title>Cancel?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>
                    Are you sure you want to cancel? All your changes will be
                    lost
                  </p>
                </Modal.Body>
                <ModalFooter>
                  <Button variant="secondary" onClick={this.safeCloseCancel}>
                    No
                  </Button>
                  <Button variant="primary" onClick={this.handleClose}>
                    Yes
                  </Button>
                </ModalFooter>
              </Modal>
            }
            {/*Save Changes Modal*/}
            {
              <Modal show={saveChange} onHide={this.closeChange}>
                <Modal.Header closeButton>
                  <Modal.Title>Save Changes?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  Save changes before changing Actions? Click YES to save, NO to
                  switch and lose your changes
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() =>
                      this.noSave(
                        this.state.tempRow,
                        role,
                        data,
                        this.state.tempController
                      )
                    }
                  >
                    No
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() =>
                      this.yesSave(
                        this.state.tempRow,
                        role,
                        data,
                        this.state.tempController
                      )
                    }
                  >
                    Yes
                  </Button>
                </Modal.Footer>
              </Modal>
            }
            {/*Delete Row Modal*/}
            {
              <Modal show={rowDelete} size="md" onHide={this.handleClose}>
                <Modal.Header>
                  <Modal.Title>
                    Delete ({this.state.stageDelete.Controller},{" "}
                    {this.state.stageDelete.Action},{" "}
                    {this.state.stageDelete.PortalRoleName})?
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>
                    Are you sure you want to delete (
                    {this.state.stageDelete.Controller},{" "}
                    {this.state.stageDelete.Action},{" "}
                    {this.state.stageDelete.PortalRoleName})?
                  </p>
                </Modal.Body>
                <ModalFooter>
                  <Button variant="secondary" onClick={this.safeCloseDelete}>
                    No
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() =>
                      this.deleteRow(
                        {
                          ActionName: this.state.stageDelete.Action,
                          Route: this.state.stageDelete.Route,
                          HttpMethods: this.state.stageDelete.HttpMethods,
                        },
                        this.state.stageDelete.Controller,
                        {
                          PortalRoleName: this.state.stageDelete.PortalRoleName,
                          IsRequired: this.state.stageDelete.IsRequired,
                          PortalRoleId: this.state.stageDelete.PortalRoleId,
                          PortalEndPointSecurityId:
                            this.state.stageDelete.PortalEndPointSecurityId,
                        }
                      )
                    }
                  >
                    Yes
                  </Button>
                </ModalFooter>
              </Modal>
            }
            {/*Test User Modal*/}
            {
              <Modal show={testRoute} size="lg" onHide={this.handleClose}>
                <Modal.Header>
                  <Modal.Title>Test User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {loadingUsers ? (
                    <Loader title="Loading Users..." />
                  ) : this.state.errorMessage ? (
                    // Surface fetch errors inside the modal rather than silently showing a blank dropdown to users
                    <p className="text-danger">{this.state.errorMessage}</p>
                  ) : testResult ? (
                    <>
                      <select
                        onChange={(e) =>
                          this.setState({ selectedUser: e.target.value })
                        }
                        value={this.state.selectedUser}
                      >
                        {this.state.allUsers.map((i) => (
                          <option key={i.UserId} value={i.UserId}>
                            {i.UserName}
                          </option>
                        ))}
                      </select>
                      <p>{testResult}</p>
                    </>
                  ) : (
                    <select
                      onChange={(e) =>
                        this.setState({ selectedUser: e.target.value })
                      }
                      defaultValue="Please Select User"
                    >
                      <option key="Please Select User" disabled>
                        Please Select User
                      </option>
                      {this.state.allUsers.map((i) => (
                        <option key={i.UserId} value={i.UserId}>
                          {i.UserName}
                        </option>
                      ))}
                    </select>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={this.handleClose}>
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    onClick={this.performTest}
                    disabled={!selectedUser}
                  >
                    Run Test
                  </Button>
                </Modal.Footer>
              </Modal>
            }
          </>
        )}
        {this.state.errorMsg && (
          <>
            <div className="EnpointSecurityErrorMsg">
              <h3>Error</h3>
              <p>{this.state.errorMsg}</p>
              <Button
                onClick={() => {
                  window.location.reload();
                }}
              >
                Refresh
              </Button>
            </div>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  username: state.user.userName,
  userid: state.user.userId,
});

export default connect(mapStateToProps)(EndpointSecurity);
